export default __webpack_public_path__ + "static/media/commingSoonImg.a2204c74.svg";